import axios from 'axios'
import { config } from '../config/config'

const reqConfig = config
const request = axios.create({
  withCredentials: false,
})

request.interceptors.request.use(
  config => {
    if (reqConfig && reqConfig.token) {
      const visitor = sessionStorage.getItem('visitor')
      if (visitor) {
        config.headers.visitor = visitor
      }
      config.headers.Authorization = 'Bearer ' + reqConfig.token
    }
    return config
  },
  error => {
    console.log('error', error)
    return Promise.reject(new Error(error).message)
  }
)

request.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    return Promise.reject(new Error(error).message)
  }
)

export default request
